/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */

import { LitElement } from "lit";
import { property } from "lit/decorators";
import { Database } from "./database";
import { Client } from "./data-classes/client";
import { Consultant } from "./data-classes/consultant";
import { ReviewRequest } from"./data-classes/review-request";
import { ConsultantClient } from "./data-classes/consultant-client";
import { User } from "./data-classes/user";
/**
 * @class HitlElement - Class which acts as interface between classes using the properties.
 * @extends LitElement
 */
export class HitlElement extends LitElement {
  
  /**
   * Variable for execute database operations
   */
  @property({ type: Object })
  database?: Database;
  
  /**
   * Variable to manage users
   */
  @property({type: Array})
  users: User[] = []; 

  /**
   * Variable to manage clients
   */
  @property({ type: Array })
  clients: Client[] = [];

  /**
   * Variable to manage consultants
   */
  @property({ type: Array })
  consultants: Consultant[] = [];

  /**
   * Variable to manage consultant-client connection
   */
  @property({type: Array})
  consultantClients: ConsultantClient[] = []
  
  /**
   * Variable to manage review-requests
   */
  @property({ type: Array })
  reviewRequests: ReviewRequest[] = [];

  /**
   * Variable to reduce review-request update
   */
  tempReviewRequests: ReviewRequest[] = [];
  
  /**
   * Variable to store the list of clients
   */
  filterClients: Client[] = [];

  /**
   * Variable to store list of consultants
   */
  filterConsultants: Consultant[] = [];

  /**
   * Dialog element to use in different pages
   */
  @property({type: Object})
  dialog?: HTMLDialogElement;

  /**
   * Current userID
   */
  @property({type: String})
  userID: string ="";
  
  /**
   * 
   * @param refresh 
   * @param scope 
   * @param cache 
   * @returns 
   */
  async getAccessToken(refresh = false, scope = "https://www.googleapis.com/auth/cloud-platform email profile", cache = true) {
    const accessToken = await new Promise<string>((resolve, reject) => {
      const getAccessToken = new CustomEvent("get-access-token", {
        bubbles: true,
        detail: { refresh: refresh, scope: scope, cache: cache, resolve: resolve, reject: reject },
      });
      this.dispatchEvent(getAccessToken);
    });
    return accessToken;
  }

  /**
   * Returns promise for accessToken either by using an existing token or by requesting a new token
   * @param e 
   */
  getAccessTokenEvent = async (e: CustomEvent) => {
    let resolve = e.detail.resolve;
    let reject = e.detail.reject;
    try {
      const accessToken = await this.getAccessToken(e.detail.refresh, e.detail.scope, e.detail.cache);
      resolve(accessToken);
    } catch (error) {
      reject(error);
    }
  };
}
